import React from "react";

const CustomButton = ({ children, onClick, type = "button", icon }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

export default CustomButton;
